import { Pipe } from '@angular/core';
import { PipeTransform } from '@nestjs/common';

@Pipe({ name: 'striphtml' })
export class StriphtmlPipe implements PipeTransform {
  transform(value: string): any {
    return value.replace(/<.*?>/g, '');
  }
}
